import { Component } from '@angular/core'

@Component({
    selector: 'persistent-dropdown-option',
    template: `
      <ng-content></ng-content>
    `
  })
export class PersistentDropdownOption {}
